import { Injectable } from '@angular/core';
import { Action } from '@ngxs/store';
import { AntiCounterfeitOrder, CreateAntiCounterfeitOrderParams } from './anti-counterfeit.model';

export class GetAntiCounterfeitOrderList {
  static readonly type = '[AntiCounterfeit] Get Order List';
  constructor(public payload: any) {}
}

export class GetAntiCounterfeitOrder {
  static readonly type = '[AntiCounterfeit] Get Order';
  constructor(public payload: number) {}
}

export class CreateAntiCounterfeitOrder {
  static readonly type = '[AntiCounterfeit] Create Order';
  constructor(public payload: CreateAntiCounterfeitOrderParams) {}
}

export class UpdateAntiCounterfeitOrder {
  static readonly type = '[AntiCounterfeit] Update Order';
  constructor(public payload: { id: number; data: Partial<AntiCounterfeitOrder> }) {}
}

export class DeleteAntiCounterfeitOrder {
  static readonly type = '[AntiCounterfeit] Delete Order';
  constructor(public payload: number) {}
}

export class ResetAntiCounterfeitHeaders {
  static readonly type = '[AntiCounterfeit] Reset Headers';
}
